import { render, staticRenderFns } from "./investment_options_with_pocket.vue?vue&type=template&id=dd599d98&"
import script from "./investment_options_with_pocket.vue?vue&type=script&lang=js&"
export * from "./investment_options_with_pocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports